export type Badge = {
  Arena5Slug: string;
  ActivityId: string;
  MinScore: number;
  MaxScore: number;
  Duration: number;
};

const GameBadges = [
  {
    Arena5Slug: "lets-crossword",
    ActivityId: "e33782b0-6676-4757-bcb0-1191f5982cca",
    MinScore: 0,
    MaxScore: 2250,
    Duration: 30,
  },
  {
    Arena5Slug: "daily-crossword",
    ActivityId: "591dfe71-d19f-4f04-8c7a-6ec7899ddaf6",
    MinScore: 500,
    MaxScore: 423150,
    Duration: 30,
  },
  {
    Arena5Slug: "daily-crossword-mini",
    ActivityId: "583a8e5f-0d27-4382-90f9-0ff88712cf66",
    MinScore: 100,
    MaxScore: 344100,
    Duration: 20,
  },
  {
    Arena5Slug: "aarp-trivia",
    ActivityId: "b9f8df64-41a6-49e3-9e2e-69e5495234b6",
    MinScore: 400,
    MaxScore: 7351,
    Duration: 0,
  },
  {
    Arena5Slug: "aarp-trivia-sports",
    ActivityId: "2bcbf2f8-1526-423f-8d39-988727db7c9e",
    MinScore: 400,
    MaxScore: 9251,
    Duration: 0,
  },
  {
    Arena5Slug: "throwback-thursday-crossword",
    ActivityId: "9db1e122-7d87-426c-8e82-1550b4f4bd11",
    MinScore: 500,
    MaxScore: 75001,
    Duration: 20,
  },
  {
    Arena5Slug: "word-wipe",
    ActivityId: "ddced37e-d982-46ff-b665-3495d930220d",
    MinScore: 400,
    MaxScore: 53000000,
    Duration: 60,
  },
  {
    Arena5Slug: "codeword",
    ActivityId: "666caa66-fac3-4394-b4e3-8ec7db9db1c9",
    MinScore: 3500,
    MaxScore: 53000000,
    Duration: 150,
  },
  {
    Arena5Slug: "outspell",
    ActivityId: "a056721a-12e0-4ab2-8068-7eea900444dc",
    MinScore: 200,
    MaxScore: 53000000,
    Duration: 60,
  },
  // {
  //   Arena5Slug: "aarp-bingo",
  //   ActivityId: "e1171c82-0da9-4cf4-a422-e0c29ad952ff",
  //   MinScore: 1,
  //   MaxScore: 99999999999,
  //   Duration: 60,
  // },
  {
    Arena5Slug: "todays-hurdle",
    ActivityId: "8a1d3bea-00d5-47d8-887f-c9b3f9fcf00b",
    MinScore: 5200,
    MaxScore: 30000,
    Duration: 1,
  },
  {
    Arena5Slug: "sudoku",
    ActivityId: "aeb79772-78ce-47f9-9918-75aa49ebe669",
    MinScore: 10000,
    MaxScore: 200000,
    Duration: 180,
  },
];

export const getBadgeByGame = (slug: string) => {
  const found = GameBadges.find((item) => item.Arena5Slug === slug);
  return found;
};
